import { useEffect, useRef } from 'react';

/** Stack of open layers (dialogs, popovers, menus): only the topmost one reacts to Escape. */
const layers: symbol[] = [];

/** Runs `handler` on Escape while `active`, but only for the most recently opened layer. */
export function useEscapeKey(handler: (() => void) | undefined, active = true): void {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!active) return;
    const token = Symbol('layer');
    layers.push(token);
    function onKeyDown(event: KeyboardEvent) {
      if (event.key !== 'Escape' || event.defaultPrevented) return;
      if (layers[layers.length - 1] !== token) return;
      const fn = handlerRef.current;
      if (!fn) return;
      event.preventDefault();
      fn();
    }
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      const index = layers.indexOf(token);
      if (index >= 0) layers.splice(index, 1);
    };
  }, [active]);
}
